import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { AutoInvoice } from "../../models/auto-invoice";

interface AutoInvoiceDeleteModalProps {
  show: boolean;
  autoInvoice?: AutoInvoice;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AutoInvoiceDeleteModal: React.FC<AutoInvoiceDeleteModalProps> = ({
  show,
  autoInvoice,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = autoInvoice
    ? `Está seguro de que quiere eliminar la autofactura ${autoInvoice.id}`
    : "";

  const onDeleteClick = async () => {
    if (autoInvoice !== undefined) {
      setSubmitting(true);
      const invoiceStatus = await deleteItem(
        `/auto_invoices/${autoInvoice.id}/`,
        autoInvoice
      );

      if (invoiceStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (invoiceStatus.detail !== undefined) {
          message = invoiceStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AutoInvoiceDeleteModal;
